import React from "react";
import { useEffect } from "react";

import GeneralNavbar from "../../components/Navbar/GeneralNavbar";
import "./PublicationsPage.css";

import publications from "./publications.json";

const PublicationCard = ({ title, body, link }) => {
	return (
		<a href={link} target="_blank" rel="noreferrer">
			<div class="pub-card">
				<div class="pub-info">
					<div class="pub-header">{title}</div>
					<div class="pub-body">{body}</div>
				</div>
			</div>
		</a>
	);
};

const PublicationsPage = () => {
	const sortedPublications = [...publications].sort(
		(a, b) => b.year - a.year
	);

	useEffect(() => {
		// change background color when component mounts
		document.body.style.backgroundColor = "white";

		// reset background color when component unmounts
		return () => {
			document.body.style.backgroundColor = "rgb(0, 53, 107)";
		};
	}, []);

	return (
		<>
			<GeneralNavbar />
			<div className="publication-page-container">
				<div className="publication-page-heading">Publications</div>
			</div>
			<div class="pub-layout">
				<div class="pub-container">
					{sortedPublications.map((publication) => (
						<PublicationCard
							key={publication.title}
							title={publication.title}
							body={publication.body}
							link={publication.link}
						/>
					))}
				</div>
			</div>
		</>
	);
};

export default PublicationsPage;
